import React from "react"
import {createRoot} from "react-dom/client"
import {StyleSheetManager} from "styled-components"
import {removeHeap} from "services/heap"

const CUSTOM_ELEMENT_NAME = "mh-widget"

const createWebComponent = App => {
  const existingElement = customElements.get(CUSTOM_ELEMENT_NAME)
  if (existingElement) return existingElement

  return customElements.define(
    CUSTOM_ELEMENT_NAME,
    class Widget extends HTMLElement {
      constructor() {
        super()

        this.styleHost = document.createElement("div")
        this.mountPoint = document.createElement("div")
        this.spriteElement = document.createElement("svg")
        this.reactRoot = createRoot(this.mountPoint)

        this.attachShadow({mode: "open"})
      }

      async connectedCallback() {
        if (this.isConnected) {
          this.shadowRoot?.appendChild(this.styleHost)
          this.shadowRoot?.appendChild(this.mountPoint)
          this.shadowRoot?.appendChild(this.spriteElement)

          this.render()
        }
      }

      disconnectedCallback() {
        removeHeap(() => window)
        if (!this.isConnected) {
          this.shadowRoot?.removeChild(this.mountPoint)
          this.shadowRoot?.removeChild(this.styleHost)
        }
      }

      render() {
        this.reactRoot.render(
          <StyleSheetManager target={this.styleHost}>
            <App />
          </StyleSheetManager>
        )
      }
    }
  )
}

export default createWebComponent
